module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-footer"
  }, [_c('div', {
    staticClass: "ushk-wrap ushk-wrap-main"
  }, [_c('div', {
    staticClass: "ushk-footer__wrap"
  }, [_c('div', {
    staticClass: "ushk-footer__l ushk-footer__link"
  }, [_c('dl', _vm._l((_vm.links), function(item) {
    return _c('dd', {
      key: item.name
    }, [_c('a', {
      attrs: {
        "href": item.link ? item.link : '#',
        "target": item.link ? '_blank' : ''
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "app-info"
  }, [_vm._l((_vm.appInfo), function(item) {
    return _c('span', [_vm._v(_vm._s(item.label))])
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./permissions.html",
      "target": "_blank"
    }
  }, [_vm._v("权限详情")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.ushknews.com/app_pages/privacy_agreement.html",
      "target": "_blank"
    }
  }, [_vm._v("隐私协议")])], 2)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "ushk-footer__wrap"
  }, [_c('div', {
    staticClass: "ushk-footer__r ushk-footer__renzheng"
  }, [_vm._l((_vm.certifications), function(item, index) {
    return _c('p', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "width": "48",
        "height": "20",
        "src": item.img,
        "srcset": item.img2x + ' 2x'
      }
    })])])
  }), _vm._v(" "), _vm._m(1)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-footer__r ushk-footer__copyright"
  }, [_c('p', [_vm._v("金十数据 广州金十信息科技有限公司 版权所有\n        ")]), _vm._v(" "), _c('p', [_vm._v("Copyright © 2013 - 现在 Jin10.com All Rights Reserved")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "http://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备16010774号-5")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010502002893",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": "https://cdn.jin10.com/assets/img/commons/gonganbeian.png",
      "alt": "",
      "width": "13"
    }
  }), _vm._v("\n            粤公网安备44010502002893号\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-footer__counselor"
  }, [_c('i', {
    staticClass: "ushk-icon ushk-icon_counselor"
  }), _vm._v(" "), _c('span', [_vm._v("常年法律顾问：广东踔厉律师事务所")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28a96fc8","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = RC9X
// module chunks = 2